interface LowercaseAtsError {
  code: string;
  message: string;
  description: string;
}

interface UppercaseAtsError {
  Code: string;
  Message: string;
  Description: string;
}

export type AtsError = LowercaseAtsError | UppercaseAtsError;

export function isLowercaseAtsError(data: unknown): data is LowercaseAtsError {
  return typeof data === 'object' && data !== null && 'code' in data && 'message' in data && 'description' in data;
}

export function isUppercaseAtsError(data: unknown): data is UppercaseAtsError {
  return typeof data === 'object' && data !== null && 'Code' in data && 'Message' in data && 'Description' in data;
}

export function isAtsError(data: unknown): data is AtsError {
  return isLowercaseAtsError(data) || isUppercaseAtsError(data);
}
